export const round = (num, precision = 2) => {
  if (typeof precision === 'string') precision = parseInt(precision, 10) || 0;
  return typeof (num) === 'number' ? num.toFixed(precision) : '';
};
